import favourites from './whats-new/favourites.png';
import rooms from './whats-new/rooms.png';
import roadmap from './whats-new/roadmap.png';

// New features shown in the "Nytt i L0LC4tor" walkthrough. To announce a
// feature, add an entry at the top and drop a screenshot in src/whats-new/.
//
// - id:    a number, one higher than the latest entry. It's what remembers that
//          someone has seen it: only the highest id seen is stored, so ids
//          must only ever go up and never be reused.
// - date:  YYYY-MM-DD. The entry pops up on its own for a month after this date
//          and stays in the footer list for a while longer (see whatsNew.js).
//          Old entries (and their screenshots) can simply be deleted.
// - image: screenshot of the feature in 16:10, taken with ?mock=1 so no real
//          people end up in it
// - title / description: Swedish, short.
export const WHATS_NEW_ENTRIES = [
    {
        id: 3,
        date: '2026-10-21',
        title: 'Se vem som är i vilket mötesrum',
        description: 'I Mötesrum ser du direkt vilka som sitter i vilket rum, bredvid kalendern. Håll musen över en avatar för att se namnet.',
        image: rooms,
    },
    {
        id: 2,
        date: '2026-10-21',
        title: 'Pinna kollegor',
        description: 'Klicka på hjärtat på ett personkort för att pinna en kollega. Pinnade kollegor hamnar överst i listan.',
        image: favourites,
    },
    {
        id: 1,
        date: '2026-10-21',
        title: 'Roadmap och önskemål',
        description: 'Se vad som är klart och på gång under Roadmap i sidfoten. Saknar du något kan du skriva i #got-lolcator på Slack.',
        image: roadmap,
    },
];
